import { Appointment, CardItemType, Patient } from "@/src/data/allTypes";
import { useEffect, useState } from "react";

import { MotiveCompartment } from "@/src/app/hospitalisation/motiveCompartment";
import { HospitalisationTreatment } from "./hospitalisationTreatment";

import { HospitalisationEventsCompartment } from "@/src/app/hospitalisation/hospitalisationEvents";

import { CardColor } from "@/src/components/cards";
import { IconTab } from "@/src/components/iconTab";
import { Hospitalisation } from "@/src/data/allTypes";
import { CONFIG, USER } from "@/src/data/globalVariables";
import { useRouterHook } from "@/src/utils/routerHook";
import { getItemId, getUserId, shouldShowVentilation } from "@/src/utils/utils";
import { BiTestTube } from "react-icons/bi";
import { FaStethoscope } from "react-icons/fa";
import { FaChartLine } from "react-icons/fa6";
import { LuCalendarDays } from "react-icons/lu";
import { PiPillBold } from "react-icons/pi";
import { CalendarPage } from "../calendar/calendarPage";
import { CurePage } from "../cure/curePage";
import { DocumentsCompartment } from "../documents/documentsCompartment";
import { AntecedentsCompartment } from "../patients/antecedentsHistory";
import { DiagnosticsHistory } from "../patients/diagnosticsHistory";
import { AnesthesiologyTreatment } from "./anesthesiologyTreatment";
import { AnswersTimelineCompartment } from "./answersTimeline/answersTimelineCompartment";
import { ConsignesCompartment } from "./consignesCompartment";
import { ExamsCompartment } from "./examsCompartment";
import GrowthChartsCompartment from "./growthChartsCompartment";
import { HospitalisationExamCompartments } from "./hospitalisationExamsCompartment";
import { MesuresAndScoresCompartment } from "./mesuresCompartment";
import { OrdonnancesCompartment } from "./ordonnancesCompartment";
import { StoryCompartment } from "./storyCompartment";
import { CgFileDocument } from "react-icons/cg";
import { MdOutlinePersonalInjury } from "react-icons/md";

function HospitalisationPage({
  appointment,
  patient,
  item,
  onChange,
  onImmediateDischarge,
}: {
  appointment: Appointment | null | undefined;
  patient: Patient;
  item: Hospitalisation;
  onImmediateDischarge: () => void;
  onChange: (newValue: Hospitalisation) => void;
}) {
  let [tabId, setTabId] = useState("hospitalisation");
  const { addParamToUrl } = useRouterHook();

  useEffect(() => {
    addParamToUrl("hospitalisationId", item.id?.split(":")[1]);
    return () => {
      addParamToUrl("hospitalisationId", null);
    };
  }, []);

  if (appointment?.protocol)
    return (
      <CurePage
        patient={patient}
        item={item}
        onImmediateDischarge={onImmediateDischarge}
        appointment={appointment}
        onChange={(newValue) => {
          item = newValue;
          onChange(newValue);
        }}
      />
    );

  if (!item.bed)
    return (
      <EmergencyHospitalisationPage
        patient={patient}
        item={item}
        onImmediateDischarge={onImmediateDischarge}
      />
    );

  const tabs: ({
    id: CardItemType;
    name: string;
    icon: any;
    color: CardColor;
    content: any;
  } | null)[] = [
    {
      id: "hospitalisation",
      name: "Données cliniques",
      color: "blue",
      icon: <FaStethoscope size={18} />,
      content: (
        <div
          className="tabContent grid c5 mc1 gap15"
          // style={{ gridTemplateColumns: "1fr 1fr 1.5fr 1fr 1fr" }}
        >
          <div className="c1 gap15">
            {/* <Button
              color="blue"
              onClick={async () => {
                let audioSession: AiAudioSession = {
                  id: `aiAudioSessions:${uid()}`,
                  items: [],
                  parent: getItemId(item),
                  creator: getUserId(),
                  beautifiedTranscript: "",
                  diagnostics: [],
                  questions: [],
                  uploads: [],
                  transcript: `
                  Patient âgé de 57 ans, aux antécédents de Diabète de type 2 sous glucophage, d'HTA sous atabek 50mg 2x jour, et d'arthrose du genoux gauche, et de PTH.
              
                    Il consulte pour prise en charge d'une douleur thoracique irradiant vers l'épaule gauche et la mâchoire.
              
                    Poids: 82 kg
                    Taille: 172 cm
              
                    ECG : RSR 70 bpm, sous décalage diffus sus décalage légère en AVR
              
                    BIOLOGIE :
                    Gb: 8900 mm3 HB: 12.5g/dl . Plq: 144000/mm3
                    Créat : 3.6 mg/l
                    Na+: 141 meq/l K+: 3.6meq/l
                    INR 1.04 TP 94 % Gly a jeun: g/l
                    Troponines 13076
              
                    Rendez-vous fixé en consultation pour une ETT le 23 décembre 2024.
              
                    Holter-ECG et MAPA en attente.
              
                    Traitement préscris en ambulatoire:
                    Aspirine 100mg 2x jour
                    Plavix 75mg 1cp 1x/j
                    Atorvastatine 80mg 1cp
                  `,
                };

                openAiAssistant({
                  patient,
                  item,
                  audioSession,
                });
              }}
            >
              Assistant
            </Button> */}
            <MotiveCompartment
              current={item?.motives || []}
              patient={patient}
              onChange={(refAnswers) => {
                item.motives = refAnswers;
              }}
            ></MotiveCompartment>

            <DiagnosticsHistory
              current={item.diagnostics || []}
              patient={patient}
              onChange={(refAnswers) => {
                item.diagnostics = refAnswers;
              }}
            ></DiagnosticsHistory>
            <StoryCompartment patient={patient} parentId={getItemId(item)} />
          </div>

          <AntecedentsCompartment patient={patient} />
          <HospitalisationEventsCompartment patient={patient} parent={item} />
          <MesuresAndScoresCompartment
            patient={patient}
            parent={item}
            color="simple"
          />

          <div className="c1 gap10">
            <DocumentsCompartment
              patient={patient}
              parent={item}
              color="blue"
            ></DocumentsCompartment>
          </div>
        </div>
      ),
    },


    {
      id: "exam",
      name: "Examens",
      color: "orange",
      icon: <BiTestTube size={18} />,
      content: (
        <div className="tabContent grid c1  gap15">
          <HospitalisationExamCompartments
            patient={patient}
            parent={item}
          ></HospitalisationExamCompartments>
        </div>
      ),
    },

    // {
    //   id: "intervention",
    //   name: "Interventions",
    //   color: "red",
    //   icon: <MdOutlinePersonalInjury size={20} />,
    //   content: (
    //     <div className="tabContent grid c1  gap15">
  
    //     </div>
    //   ),
    // },


    USER.get()?.speciality?.name?.toLowerCase() == "pédiatrie"
      ? {
          id: "mesure",
          color: "red",
          name: "Courbes de croissance",
          icon: <FaChartLine size={18} />,
          content: (
            <div className="tabContent grid c1 mc1 gap15">
              {" "}
              <GrowthChartsCompartment patient={patient} parent={item} />
            </div>
          ),
        }
      : null,

    {
      id: "ordonnance",
      name: "Traitement",
      color: "purple",

      icon: <PiPillBold size={18} />,
      content: (
        <div className="tabContent grid c5 mc1 gap15">
          <div className="triple msingle c1 gap10">
            <HospitalisationTreatment
              patient={patient}
              parent={item}
            ></HospitalisationTreatment>
            {shouldShowVentilation(USER?.get()) && (
              <AnswersTimelineCompartment
                color="purple"
                title={"Ventilation"}
                patient={patient}
                parent={item}
                referenceIds={[CONFIG.get()?.ventilationForm?.id!]}
                initialStatus="pending"
              ></AnswersTimelineCompartment>
            )}

            <AnesthesiologyTreatment
              patient={patient}
              item={item}
            ></AnesthesiologyTreatment>
          </div>

          <ConsignesCompartment
            patient={patient}
            parent={item}
          ></ConsignesCompartment>
          <OrdonnancesCompartment
            patient={patient}
            parent={item}
            onChange={(newValue) => {
              console.log({ newValue });
            }}
          ></OrdonnancesCompartment>
        </div>
      ),
    },

    // {
    //   id: "document",
    //   name: "Sortie",
    //   color: "green",
    //   icon: <CgFileDocument size={18} />,
    //   content: (
    //     <div className="tabContent green-compartments grid c3 mc1 gap15">
    //       <DocumentsCompartment
    //         patient={patient}
    //         parent={item}
    //       ></DocumentsCompartment>
    //       <OrdonnancesCompartment
    //         color="green"
    //         patient={patient}
    //         parent={item}
    //         onChange={(newValue) => {
    //           console.log({ newValue });
    //         }}
    //       ></OrdonnancesCompartment>
    //       <SortieCompartment
    //         patient={patient}
    //         parent={item}
    //         onImmediateDischarge={onImmediateDischarge}
    //       ></SortieCompartment>
    //     </div>
    //   ),
    // },
  ];

  const selectedTab = tabs.find((tab) => tab?.id == tabId);
  let tabsLength = tabs.filter((tab) => tab != null).length;

  return (
    <div className="tabsPage">
      {
        <div className={`grid c${tabsLength} mc${tabsLength} gap15 mgap10`}>
          {tabs.map((tab) => {
            if (!tab) return null;
            return (
              <IconTab
                key={`item-${tab.id}`}
                color={tab.color}
                activeTabId={tabId}
                icon={tab.icon}
                id={tab.id}
                name={tab.name}
                onChange={(tab) => {
                  setTabId(tab);
                }}
              />
            );
          })}
        </div>
      }

      {selectedTab?.content}
    </div>
  );
}

function EmergencyHospitalisationPage({
  patient,
  item,
  onImmediateDischarge,
}: {
  patient: Patient;
  item: Hospitalisation;
  onImmediateDischarge: () => void;
}) {
  let [tabId, setTabId] = useState("hospitalisation");

  const tabs: ({
    id: CardItemType;
    name: string;
    icon: any;
    color: CardColor;
    content: any;
  } | null)[] = [
    {
      id: "hospitalisation",
      name: "Données médicales",
      color: "blue",
      icon: <FaStethoscope size={18} />,
      content: (
        <div className="tabContent grid c6 mc1 gap15">
          <div className="c1 gap15">
            <MotiveCompartment
              current={item?.motives || []}
              patient={patient}
              onChange={(refAnswers) => {
                item.motives = refAnswers;
              }}
            ></MotiveCompartment>

            <DiagnosticsHistory
              current={item.diagnostics || []}
              patient={patient}
              onChange={(refAnswers) => {
                item.diagnostics = refAnswers;
              }}
            ></DiagnosticsHistory>
            <StoryCompartment patient={patient} parentId={getItemId(item)} />
          </div>
          <AntecedentsCompartment patient={patient} />

          <div className="c1 gap10">
            <HospitalisationEventsCompartment
              patient={patient}
              parent={item}
              title="Evènements"
            />
          </div>
          <MesuresAndScoresCompartment
            patient={patient}
            parent={item}
            color="simple"
          />
          <ExamsCompartment
            patient={patient}
            parent={item}
            type="blue"
            title="Examens"
          ></ExamsCompartment>

          <div className="c1 gap10">
            <DocumentsCompartment
              patient={patient}
              parent={item}
              color="blue"
            ></DocumentsCompartment>
          </div>
        </div>
      ),
    },

    // {
    //   id: "exam",
    //   name: "Examens",
    //   color: "orange",
    //   icon: <BiTestTube size={18} />,
    //   content: (
    //     <div className="tabContent grid c1  gap15">
    //       <ExamsCompartment patient={patient} parent={item}></ExamsCompartment>
    //     </div>
    //   ),
    // },

    USER.get()?.speciality?.name?.toLowerCase() == "pédiatrie"
      ? {
          id: "mesure",
          color: "red",
          name: "Courbes de croissance",
          icon: <FaChartLine size={18} />,
          content: (
            <div className="tabContent grid c1 mc1 gap15">
              {" "}
              <GrowthChartsCompartment patient={patient} parent={item} />
            </div>
          ),
        }
      : null,

    {
      id: "ordonnance",
      name: "Traitement",
      color: "purple",
      icon: <PiPillBold size={18} />,
      content: (
        <div className="tabContent grid c5 mc1 gap15">
          <div className="triple msingle">
            <HospitalisationTreatment
              patient={patient}
              parent={item}
            ></HospitalisationTreatment>
          </div>

          <ConsignesCompartment
            patient={patient}
            parent={item}
          ></ConsignesCompartment>

          <OrdonnancesCompartment
            patient={patient}
            parent={item}
            // color="blue"
            onChange={(newValue) => {
              console.log({ newValue });
            }}
          ></OrdonnancesCompartment>
        </div>
      ),
    },
    {
      id: "appointment",
      color: "red",
      name: "Rendez-vous",
      icon: <LuCalendarDays size={18} />,
      content: (
        <div className="tabContent grid c1 gap20">
          <CalendarPage userId={getUserId()} patient={patient}></CalendarPage>
        </div>
      ),
    },

    // {
    //   id: "document",
    //   name: "Sortie",
    //   color: "green",
    //   icon: <CgFileDocument size={18} />,
    //   content: (
    //     <div className="tabContent green-compartments grid c2 mc1 gap15">
    //       <DocumentsCompartment
    //         patient={patient}
    //         parent={item}
    //       ></DocumentsCompartment>

    //       <SortieCompartment
    //         patient={patient}
    //         parent={item}
    //         onImmediateDischarge={onImmediateDischarge}
    //       ></SortieCompartment>
    //     </div>
    //   ),
    // },
  ];
  // const tabs: {
  //   id: CardItemType;
  //   name: string;
  //   icon: any;
  //   color: CardColor;
  //   content: any;
  // }[] = [
  //   {
  //     id: "hospitalisation",
  //     name: "Données cliniques",
  //     color: "blue",
  //     icon: <FaStethoscope size={18} />,
  //     content: (
  //       <div className="tabContent grid c5 mc1 gap15">
  //         <MotiveCompartment
  //           current={item?.motives || []}
  //           patient={patient}
  //           onChange={(refAnswers) => {
  //             item.motives = refAnswers;
  //           }}
  //         ></MotiveCompartment>

  //         <AntecedentsCompartment patient={patient} />
  //         <StoryCompartment patient={patient} parentId={getItemId(item)} />
  //         <HospitalisationEvolutionCompartment
  //           patient={patient}
  //           parent={item}
  //         />
  //         <DiagnosticsHistory
  //           current={item.diagnostics || []}
  //           patient={patient}
  //           onChange={(refAnswers) => {
  //             item.diagnostics = refAnswers;
  //           }}
  //         ></DiagnosticsHistory>
  //         {/* <MesuresAndScoresCompartment patient={patient} parent={item} /> */}
  //       </div>
  //     ),
  //   },
  //   {
  //     id: "mesure",
  //     name: "Mesures et scores",
  //     color: "red",
  //     icon: <FaRegChartBar size={18} />,
  //     content: (
  //       <div className="tabContent grid c2 mc1 gap15">
  //         <MesuresCompartment patient={patient} parent={item} />
  //         <ScoresCompartment patient={patient} parent={item} />
  //       </div>
  //     ),
  //   },
  //   {
  //     id: "exam",
  //     name: "Examens",
  //     color: "orange",
  //     icon: <BiTestTube size={18} />,
  //     content: (
  //       <div className="tabContent grid c1  gap15">
  //         <ExamsCompartment patient={patient} parent={item}></ExamsCompartment>
  //       </div>
  //     ),
  //   },

  //   {
  //     id: "ordonnance",
  //     name: "Treatment",
  //     color: "purple",
  //     icon: <PiPillBold size={18} />,
  //     content: (
  //       <div className="tabContent grid c4 mc1 gap15">
  //         <div className="double msingle">
  //           <HospitalisationTreatment
  //             patient={patient}
  //             parent={item}
  //           ></HospitalisationTreatment>
  //         </div>

  //         <OrdonnancesCompartment
  //           patient={patient}
  //           parent={item}
  //           onChange={(newValue) => {
  //             console.log({ newValue });
  //           }}
  //         ></OrdonnancesCompartment>

  //         <ConsignesCompartment
  //           patient={patient}
  //           parent={item}
  //         ></ConsignesCompartment>
  //       </div>
  //     ),
  //   },

  //   {
  //     id: "document",
  //     name: "Sortie",
  //     color: "green",
  //     icon: <CgFileDocument size={18} />,
  //     content: (
  //       <div className="tabContent green-compartments grid c2 mc1 gap15">
  //         <DocumentsCompartment
  //           patient={patient}
  //           parent={item}
  //         ></DocumentsCompartment>

  //         <SortieCompartment
  //           patient={patient}
  //           parent={item}
  //           onImmediateDischarge={onImmediateDischarge}
  //         ></SortieCompartment>
  //       </div>
  //     ),
  //   },
  // ];

  const selectedTab = tabs.find((tab) => tab?.id == tabId);
  const tabsLength = tabs.filter((tab) => tab != null).length;

  return (
    <div className="tabsPage">
      {tabs.length > 1 && (
        <div className={`grid c${tabsLength} mc${tabsLength} gap15`}>
          {tabs.map((tab) => {
            if (!tab) return null;
            return (
              <IconTab
                key={`item-${tab.id}`}
                color={tab.color}
                activeTabId={tabId}
                icon={tab.icon}
                id={tab.id}
                name={tab.name}
                onChange={(tab) => {
                  setTabId(tab);
                }}
              />
            );
          })}
        </div>
      )}
      {tabsLength <= 1 && <div></div>}

      {selectedTab?.content}
    </div>
  );
}

export { HospitalisationPage };
